export enum CombinedTyresPosition {
    frontTyres = "frontTyres",
    rearTyres = "rearTyres",
}
